import React from 'react';
import './Loading.css'; // Optional: Add custom styles for the loader

const Loading = () => {
    return (
        <div className="loading-container">
            <div className="spinner"></div>
        </div>
    );
};

export default Loading;